// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xg4w","content":"styles_content__3mWwg"};